module.exports = __webpack_public_path__ + "static/ConsultFGC_couch-4a2db2d27065d87016716ef2296956ba.jpg";